/* eslint-disable import/prefer-default-export */

export enum ReferAFriendCampaignType {
  Referrer = 'Referrer',
  Referee = 'Referee',
}
